"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateActionWithMCP = exports.MCPForDAServerUrlNode = exports.m365SearchMeSubNode = exports.meProjectTypeNode = exports.tabProjectTypeNode = exports.botProjectTypeNode = exports.notificationBotTriggerNode = exports.inputOrSearchAPISpecNode = exports.apiSpecWithSearchNode = exports.apiSpecNode = exports.llmServiceNode = exports.azureOpenAINode = exports.customCopilotRagNode = exports.TeamsProjectTypeOptions = exports.teamsProjectNode = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
const create_1 = require("../../create");
const questionNames_1 = require("../../questionNames");
const CapabilityOptions_1 = require("./CapabilityOptions");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const path_1 = tslib_1.__importDefault(require("path"));
const fs = tslib_1.__importStar(require("fs-extra"));
function teamsProjectNode(platform) {
    return {
        // project-type = Teams Agents and Apps
        condition: { equals: ProjectTypeOptions_1.ProjectTypeOptions.teamsOptionId },
        data: {
            name: questionNames_1.QuestionNames.TeamsAppType,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.teamsAgentsAndApps.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.TeamsAgentCapabilityOptions.basicChatbot(),
                CapabilityOptions_1.TeamsAgentCapabilityOptions.customCopilotRag(),
                CapabilityOptions_1.TeamsAgentCapabilityOptions.collaboratorAgent(),
                CapabilityOptions_1.TeamsAgentCapabilityOptions.others(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [
            customCopilotRagNode(),
            // aiAgentNode(),
            llmServiceNode({
                enum: [
                    CapabilityOptions_1.TeamsAgentCapabilityOptions.basicChatbot().id,
                    CapabilityOptions_1.TeamsAgentCapabilityOptions.customCopilotRag().id,
                ],
            }),
            azureOpenAINode({ equals: CapabilityOptions_1.TeamsAgentCapabilityOptions.collaboratorAgent().id }),
            teamsCapabilityNode(platform),
        ],
    };
}
exports.teamsProjectNode = teamsProjectNode;
function teamsCapabilityNode(platform) {
    return {
        // teams-app-type = Others
        condition: { equals: CapabilityOptions_1.TeamsAgentCapabilityOptions.others().id },
        data: {
            name: questionNames_1.QuestionNames.TeamsCapability,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.teamsCapability.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.TabCapabilityOptions.nonSsoTab(),
                CapabilityOptions_1.MeCapabilityOptions.basicMe(),
                CapabilityOptions_1.BotCapabilityOptions.basicBot(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [],
    };
}
class TeamsProjectTypeOptions {
    static tab(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: TeamsProjectTypeOptions.tabOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(browser) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.TabOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.tab.detail"),
        };
    }
    static bot(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: TeamsProjectTypeOptions.botOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(hubot) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.bot.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.bot.detail"),
        };
    }
    static me(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: TeamsProjectTypeOptions.meOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(symbol-keyword) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.messageExtension.copilotEnabled.detail"),
        };
    }
}
exports.TeamsProjectTypeOptions = TeamsProjectTypeOptions;
TeamsProjectTypeOptions.tabOptionId = "tab-type";
TeamsProjectTypeOptions.botOptionId = "bot-type";
TeamsProjectTypeOptions.meOptionId = "me-type";
function customCopilotRagNode() {
    return {
        condition: { equals: CapabilityOptions_1.TeamsAgentCapabilityOptions.customCopilotRag().id },
        data: {
            type: "singleSelect",
            name: questionNames_1.QuestionNames.CustomCopilotRag,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRagOption.label"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.capability.customCopilotRag.placeholder"),
            staticOptions: [
                CapabilityOptions_1.CustomCopilotRagOptions.customize(),
                CapabilityOptions_1.CustomCopilotRagOptions.azureAISearch(),
                CapabilityOptions_1.CustomCopilotRagOptions.customApi(),
                // CustomCopilotRagOptions.microsoft365(),
            ],
            default: CapabilityOptions_1.CustomCopilotRagOptions.customize().id,
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [apiSpecNode({ equals: CapabilityOptions_1.CustomCopilotRagOptions.customApi().id })],
    };
}
exports.customCopilotRagNode = customCopilotRagNode;
// export function aiAgentNode(): IQTreeNode {
//   return {
//     condition: { equals: CustomCopilotCapabilityOptions.aiAgent().id },
//     data: {
//       type: "singleSelect",
//       name: QuestionNames.CustomCopilotAssistant,
//       title: getLocalizedString(
//         "core.createProjectQuestion.capability.customCopilotAssistant.title"
//       ),
//       placeholder: getLocalizedString(
//         "core.createProjectQuestion.capability.customCopilotAssistant.placeholder"
//       ),
//       staticOptions: [
//         CustomCopilotAssistantOptions.new(),
//         CustomCopilotAssistantOptions.assistantsApi(),
//       ],
//       default: CustomCopilotAssistantOptions.new().id,
//       onDidSelection: setTemplateName,
//     },
//   };
// }
function azureOpenAINode(condition) {
    return {
        condition: condition,
        data: {
            type: "text",
            password: true,
            name: questionNames_1.QuestionNames.AzureOpenAIKey,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIKey.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIKey.placeholder"),
        },
        children: [
            {
                condition: (inputs) => {
                    var _a;
                    return ((_a = inputs[questionNames_1.QuestionNames.AzureOpenAIKey]) === null || _a === void 0 ? void 0 : _a.length) > 0;
                },
                data: {
                    type: "text",
                    name: questionNames_1.QuestionNames.AzureOpenAIEndpoint,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIEndpoint.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIEndpoint.placeholder"),
                },
                children: [
                    {
                        condition: (inputs) => {
                            var _a;
                            return ((_a = inputs[questionNames_1.QuestionNames.AzureOpenAIEndpoint]) === null || _a === void 0 ? void 0 : _a.length) > 0;
                        },
                        data: {
                            type: "text",
                            name: questionNames_1.QuestionNames.AzureOpenAIDeploymentName,
                            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIDeploymentName.title"),
                            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.azureOpenAIDeploymentName.placeholder"),
                        },
                    },
                ],
            },
        ],
    };
}
exports.azureOpenAINode = azureOpenAINode;
function llmServiceNode(condition) {
    return {
        condition: condition,
        data: {
            type: "singleSelect",
            name: questionNames_1.QuestionNames.LLMService,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.title"),
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.placeholder"),
            staticOptions: [
                {
                    id: "llm-service-azure-openai",
                    label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceAzureOpenAIOption.label"),
                    detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceAzureOpenAIOption.detail"),
                },
                {
                    id: "llm-service-openai",
                    label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceOpenAIOption.label"),
                    detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmServiceOpenAIOption.detail"),
                },
            ],
            skipSingleOption: true,
            default: "llm-service-azure-openai",
        },
        children: [
            azureOpenAINode({ equals: "llm-service-azure-openai" }),
            {
                condition: { equals: "llm-service-openai" },
                data: {
                    type: "text",
                    password: true,
                    name: questionNames_1.QuestionNames.OpenAIKey,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.openAIKey.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.llmService.openAIKey.placeholder"),
                },
            },
        ],
    };
}
exports.llmServiceNode = llmServiceNode;
function apiSpecNode(condition) {
    return {
        condition: condition,
        data: { type: "group", name: questionNames_1.QuestionNames.FromExistingApi },
        children: [
            {
                data: (0, create_1.apiSpecLocationQuestion)(),
            },
            {
                condition: (inputs) => {
                    return !inputs[questionNames_1.QuestionNames.ActionManifestPath];
                },
                data: (0, create_1.apiOperationQuestion)(),
            },
        ],
    };
}
exports.apiSpecNode = apiSpecNode;
function apiSpecWithSearchNode() {
    return {
        data: { type: "group", name: questionNames_1.QuestionNames.FromExistingApi },
        condition: { equals: "api-spec" },
        children: [inputOrSearchAPISpecNode()],
    };
}
exports.apiSpecWithSearchNode = apiSpecWithSearchNode;
function inputOrSearchAPISpecNode() {
    return {
        data: (0, create_1.apiSpecTypeSelectQuestion)(),
        condition: (inputs) => {
            return featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaNPMIntegration);
        },
        children: [
            {
                condition: { equals: "enter-url-or-open-local-file" },
                data: (0, create_1.apiSpecLocationQuestion)(),
                children: [
                    {
                        condition: (inputs) => {
                            return !inputs[questionNames_1.QuestionNames.ActionManifestPath];
                        },
                        data: (0, create_1.apiOperationQuestion)(true, true),
                    },
                ],
            },
            {
                condition: { equals: "search-api" },
                data: (0, create_1.searchOpenAPISpecQueryQuestion)(),
                children: [
                    {
                        data: (0, create_1.selectOpenApiSpecQuestion)(),
                    },
                    {
                        condition: (inputs) => {
                            return !!inputs[questionNames_1.QuestionNames.SelectOpenApiSpec];
                        },
                        data: (0, create_1.apiOperationQuestion)(true, true),
                    },
                ],
            },
        ],
    };
}
exports.inputOrSearchAPISpecNode = inputOrSearchAPISpecNode;
function notificationBotTriggerNode(platform = teamsfx_api_1.Platform.VSCode) {
    return {
        condition: { equals: CapabilityOptions_1.BotCapabilityOptions.notificationBotId },
        data: {
            name: questionNames_1.QuestionNames.BotTrigger,
            title: (0, localizeUtils_1.getLocalizedString)("plugins.bot.questionHostTypeTrigger.title"),
            type: "singleSelect",
            cliDescription: "Specifies the trigger for `Chat Notification Message` app template.",
            staticOptions: [
                platform === teamsfx_api_1.Platform.VS
                    ? CapabilityOptions_1.NotificationBotOptions.appServiceForVS()
                    : CapabilityOptions_1.NotificationBotOptions.appService(),
                CapabilityOptions_1.NotificationBotOptions.functionsHttpAndTimerTrigger(),
                CapabilityOptions_1.NotificationBotOptions.functionsHttpTrigger(),
                CapabilityOptions_1.NotificationBotOptions.functionsTimerTrigger(),
            ],
            default: platform === teamsfx_api_1.Platform.VS
                ? CapabilityOptions_1.NotificationBotOptions.appServiceForVS().id
                : CapabilityOptions_1.NotificationBotOptions.appService().id,
            placeholder: (0, localizeUtils_1.getLocalizedString)("plugins.bot.questionHostTypeTrigger.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
    };
}
exports.notificationBotTriggerNode = notificationBotTriggerNode;
function botProjectTypeNode() {
    return {
        // project-type = Bot
        condition: { equals: TeamsProjectTypeOptions.botOptionId },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.bot.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.BotCapabilityOptions.basicBot(),
                CapabilityOptions_1.BotCapabilityOptions.notificationBot(),
                CapabilityOptions_1.BotCapabilityOptions.commandBot(),
                CapabilityOptions_1.BotCapabilityOptions.workflowBot(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [notificationBotTriggerNode()],
    };
}
exports.botProjectTypeNode = botProjectTypeNode;
function tabProjectTypeNode(platform = teamsfx_api_1.Platform.VSCode) {
    return {
        // project-type = Tab
        condition: { equals: TeamsProjectTypeOptions.tabOptionId },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.tab.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.TabCapabilityOptions.nonSsoTab(),
                CapabilityOptions_1.TabCapabilityOptions.m365SsoLaunchPage(),
                CapabilityOptions_1.TabCapabilityOptions.dashboardTab(),
                CapabilityOptions_1.TabCapabilityOptions.SPFxTab(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [
            {
                //SPFx sub-tree
                condition: { equals: CapabilityOptions_1.TabCapabilityOptions.SPFxTab().id },
                data: (0, create_1.SPFxSolutionQuestion)(),
                children: [
                    {
                        data: { type: "group" },
                        children: [
                            { data: (0, create_1.SPFxPackageSelectQuestion)() },
                            { data: (0, create_1.SPFxFrameworkQuestion)() },
                            { data: (0, create_1.SPFxWebpartNameQuestion)() },
                        ],
                        condition: { equals: "new" },
                    },
                    {
                        data: (0, create_1.SPFxImportFolderQuestion)(),
                        condition: { equals: "import" },
                    },
                ],
            },
        ],
    };
}
exports.tabProjectTypeNode = tabProjectTypeNode;
function meProjectTypeNode() {
    return {
        // project-type = Messaging Extension
        condition: { equals: TeamsProjectTypeOptions.meOptionId },
        data: {
            name: questionNames_1.QuestionNames.Capabilities,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.messageExtension.title"),
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.MeCapabilityOptions.m365SearchMe(),
                CapabilityOptions_1.MeCapabilityOptions.collectFormMe(),
                CapabilityOptions_1.MeCapabilityOptions.linkUnfurling(),
            ],
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createCapabilityQuestion.placeholder"),
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [m365SearchMeSubNode()],
    };
}
exports.meProjectTypeNode = meProjectTypeNode;
function m365SearchMeSubNode() {
    return {
        // Search ME sub-tree
        condition: { equals: CapabilityOptions_1.MeCapabilityOptions.m365SearchMe().id },
        data: {
            name: questionNames_1.QuestionNames.MeArchitectureType,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.meArchitecture.title"),
            cliDescription: "The authentication type for the API.",
            type: "singleSelect",
            staticOptions: [
                CapabilityOptions_1.MeArchitectureOptions.newApi(),
                CapabilityOptions_1.MeArchitectureOptions.openApiSpec(),
                CapabilityOptions_1.MeArchitectureOptions.botMe(),
            ],
            default: CapabilityOptions_1.MeArchitectureOptions.newApi().id,
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotExtension.placeholder"),
            forgetLastValue: true,
            skipSingleOption: true,
            onDidSelection: CapabilityOptions_1.setTemplateName,
        },
        children: [
            {
                condition: { equals: CapabilityOptions_1.MeArchitectureOptions.newApi().id },
                data: {
                    type: "singleSelect",
                    name: questionNames_1.QuestionNames.ApiAuth,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiMessageExtensionAuth.title"),
                    placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.apiMessageExtensionAuth.placeholder"),
                    staticOptions: [
                        CapabilityOptions_1.ApiAuthOptions.none(true),
                        CapabilityOptions_1.ApiAuthOptions.bearerToken(),
                        CapabilityOptions_1.ApiAuthOptions.microsoftEntra(true),
                    ],
                    default: CapabilityOptions_1.ApiAuthOptions.none(true).id,
                    onDidSelection: CapabilityOptions_1.setTemplateName,
                },
            },
            apiSpecNode({ equals: CapabilityOptions_1.MeArchitectureOptions.openApiSpec().id }),
        ],
    };
}
exports.m365SearchMeSubNode = m365SearchMeSubNode;
function MCPForDAServerUrlNode() {
    return {
        condition: { equals: CapabilityOptions_1.ActionStartOptions.mcp().id },
        data: {
            name: questionNames_1.QuestionNames.MCPForDAServerUrl,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.mcpForDa.ServerUrl.title"),
            type: "text",
            placeholder: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.mcpForDa.ServerUrl.placeholder"),
        },
    };
}
exports.MCPForDAServerUrlNode = MCPForDAServerUrlNode;
function updateActionWithMCP() {
    return {
        data: {
            type: "singleFile",
            name: questionNames_1.QuestionNames.PluginManifestFilePath,
            title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.mcpForDa.File.title"),
            defaultFolder: (inputs) => path_1.default.normalize(inputs.projectPath),
            default: (inputs) => path_1.default.normalize(path_1.default.join(inputs.projectPath, teamsfx_api_1.AppPackageFolderName, teamsfx_api_1.DefaultPluginManifestFileName)),
        },
        children: [
            {
                data: {
                    type: "multiSelect",
                    name: questionNames_1.QuestionNames.MCPForDAPreFetchTools,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.mcpForDa.PreFetchTools.title"),
                    staticOptions: [],
                    dynamicOptions: (inputs) => {
                        const availableTools = inputs[questionNames_1.QuestionNames.MCPForDAAvailableTools];
                        const tools = availableTools.map((tool) => {
                            return {
                                id: tool.name,
                                label: tool.name,
                                detail: tool.description || "",
                            };
                        });
                        return tools;
                    },
                    default: async (inputs) => {
                        const pluginManifestFilePath = inputs[questionNames_1.QuestionNames.PluginManifestFilePath];
                        if (!pluginManifestFilePath) {
                            return [];
                        }
                        const pluginManifest = await fs.readJSON(pluginManifestFilePath);
                        const serverUrl = inputs[questionNames_1.QuestionNames.MCPForDAServerUrl];
                        const result = [];
                        pluginManifest.runtimes
                            .filter((runtime) => runtime.type === "RemoteMCPServer" &&
                            runtime.spec.url === serverUrl &&
                            runtime.spec["enable_dynamic_discovery"] === false)
                            .forEach((runtime) => {
                            result.push(...runtime["run_for_functions"]);
                        });
                        return result;
                    },
                },
            },
            {
                condition: (inputs) => {
                    return inputs[questionNames_1.QuestionNames.MCPForDAAuth] !== "NoneAuth";
                },
                data: {
                    type: "singleSelect",
                    name: questionNames_1.QuestionNames.MCPForDAAuthType,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.mcpForDa.AuthType.title"),
                    staticOptions: [
                        {
                            id: "oauth",
                            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.mcpForDa.Auth.OAuth"),
                        },
                        {
                            id: "entraSSO",
                            label: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.mcpForDa.Auth.EntraSSO"),
                        },
                    ],
                    default: "oauth",
                },
            },
        ],
    };
}
exports.updateActionWithMCP = updateActionWithMCP;
//# sourceMappingURL=teamsProjectTypeNode.js.map